import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedEnableModeSelector, setSelectedEnableMode } from '../filtersSlice';
import { SelectedBooleanStatusType } from '../utils';

export const useSelectedEnabledMode = () => {
  const dispatch = useDispatch();
  const enableMode = useSelector(selectedEnableModeSelector);

  const onSelectEnableMode = React.useCallback((selected: SelectedBooleanStatusType) => {
    dispatch(setSelectedEnableMode(selected));
  }, [dispatch]);

  return {
    enableMode,
    onSelectEnableMode,
  };
};
